import { useEngineModeSignal } from "../../../rx/signal/useEngineModeSignal"
import createEngineForGamePlay from "./createEngineForGamePlay"
import { EngineMode } from "./EngineMode/EngineMode.enum"

export default function createEngineForReplay () {
  const engine = createEngineForGamePlay()
  const [, setEngineMode] = useEngineModeSignal(engine)
  setEngineMode(EngineMode.Replay)
  return engine
}
